import React from 'react'
import classnames from 'classnames/bind'

import Layout from 'components/shared/Layout'
import Image from 'components/shared/Image'
import LabelTitleText from 'components/shared/LabelTitleText'
import TriangleImage from 'components/shared/TriangleImage'
import Parallax from 'components/shared/Parallax'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const FeaturesHero = ({
  intro,
  smallScreenAsideImage,
  asideImage,
  triangleImage,
  displayTopTriangle,
}) => {
  return (
    <section className={cx(css.FeaturesHero)}>
      <div className={css.heroContainer}>
        <Layout type="maxWidth">
          <Layout type="wrapper" className={css.heroWrapper}>
            {smallScreenAsideImage && (
              <Image
                className={css.mainImageMobile}
                {...smallScreenAsideImage}
              />
            )}
            {!smallScreenAsideImage && asideImage && (
              <Image className={css.mainImageMobile} {...asideImage} />
            )}
            {intro && (
              <Layout type="innerWrapper" className={css.innerWrapper}>
                <LabelTitleText
                  {...intro}
                  titleProps={{ tag: 'h1', size: 'extra-large' }}
                  textProps={{ tag: 'h2' }}
                  className={css.contentWrapper}
                />
              </Layout>
            )}
          </Layout>
          {triangleImage && (
            <div className={css.triangleImage}>
              <TriangleImage type="bottom-left" {...triangleImage} />
            </div>
          )}
          {displayTopTriangle && (
            <Image
              className={css.topTriangle}
              media={{ width: 636, height: 638 }}
              src="/assets/decoration/triangle.svg"
            />
          )}
          {asideImage && asideImage.media && (
            <Parallax distance={9}>
              {(ref) => (
                <Image
                  ref={ref}
                  format="null"
                  className={css.mainImage}
                  {...asideImage}
                />
              )}
            </Parallax>
          )}
        </Layout>
      </div>
    </section>
  )
}

FeaturesHero.defaultProps = {}

export default FeaturesHero
